var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2412,
	"./chat-icon-bottom-nav-mobile.webp": 2413,
	"./home-icon-bottom-nav-mobile-active.webp": 2414,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2415,
	"./home-icon-bottom-nav-mobile.webp": 2416,
	"./home-icon-bottom-nav-mobile_b.webp": 2417,
	"./me-icon-bottom-nav-mobile-active.webp": 2418,
	"./me-icon-bottom-nav-mobile.webp": 2419,
	"./promo-icon-bottom-nav-mobile-active.webp": 2420,
	"./promo-icon-bottom-nav-mobile.webp": 2421,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2422,
	"./sponsor-icon-bottom-nav-mobile.webp": 2423,
	"./stream-icon-bottom-nav-mobile-active.webp": 2424,
	"./stream-icon-bottom-nav-mobile.webp": 2425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2411;